import {useEvent} from 'Event/EventProvider'
import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

import Button from 'lib/ui/Button'
import {useToggle} from 'lib/toggle'
import {ConvertKitTag} from 'organization/Event/Services/Apps/ConvertKit/Config/Tags'
import AutocompleteTags, {
  CreateNewTagDialog,
} from 'organization/Event/Services/Apps/ConvertKit/Config/Tags/AutocompleteTags'
import IntegrationTagField from 'organization/Event/DashboardConfig/IntegrationTagField'

export default function ConvertKitTagInput(props: {
  onChange: (tag: ConvertKitTag | null) => void
  value?: ConvertKitTag | null
  disabled?: boolean
  inputVariant?: 'filled' | 'standard' | 'outlined'
  label?: string
}) {
  const {value, onChange, label, inputVariant} = props

  const {event} = useEvent()
  const {flag: showCreateForm, toggle: toggleShowCreateForm} = useToggle()
  if (!event.has_convert_kit) {
    return null
  }

  const handleOnCreate = (newTag: ConvertKitTag) => {
    toggleShowCreateForm()
    onChange(newTag)
  }

  return (
    <>
      <IntegrationTagField>
        <AutocompleteTags
          inputLabel={label ?? 'Convert Kit Tag'}
          value={value}
          onChange={onChange}
          inputVariant={inputVariant ?? 'outlined'}
          disabled={props.disabled ?? false}
          endAdornment={(loading, arrow) =>
            loading ? (
              <>
                <CircularProgress color="inherit" size={20} />
              </>
            ) : (
              <>
                {arrow}
                <Button
                  color="primary"
                  size="large"
                  aria-label="create tag"
                  onClick={toggleShowCreateForm}
                >
                  Create new tag
                </Button>
              </>
            )
          }
        />
      </IntegrationTagField>
      <CreateNewTagDialog
        visible={showCreateForm}
        onClose={toggleShowCreateForm}
        onCreate={handleOnCreate}
      />
    </>
  )
}
